import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import ProductOptionSwatch from "./product-option-swatch";
import ProductOptionPreview from "./product-option-preview";

export default function ProductOptionSwatchesGroup({
  groupTitle,
  madeToOrder,
  optionValues,
  selectedOptionValue,
  selectedVariant,
  disabledOptionValues,
  updateOptionValue,
  optionName,
  enableSwatchPreview,
}) {
  const [previewOpen, setPreviewOpen] = useState(false);

  const optionInGroupSelected = optionValues.some(
    (optionValue) => optionValue.name === selectedOptionValue,
  );

  return (
    <div className="product-options__swatch-group">
      <div className="product-options__swatch-group-header">
        <div className="product-options__swatch-group-title">{groupTitle}</div>
        {madeToOrder && (
          <div className="product-options__swatch-group-subtitle">
            {window.localeStrings.product.made_to_order_time_estimate}
          </div>
        )}
      </div>
      {enableSwatchPreview && (
        <ProductOptionPreview
          selectedVariant={selectedVariant}
          selectedOptionValue={selectedOptionValue}
          groupTitle={groupTitle}
          open={previewOpen}
          setOpen={setPreviewOpen}
          optionInGroupSelected={optionInGroupSelected}
        />
      )}
      <div className="product-options__swatch-list">
        {optionValues.map((optionValue) => (
          <ProductOptionSwatch
            key={optionValue.name}
            optionValue={optionValue}
            optionName={optionName}
            disabled={disabledOptionValues.includes(optionValue.name)}
            updateOptionValue={updateOptionValue}
            selected={optionValue.name === selectedOptionValue}
            onClick={() => setPreviewOpen(true)}
          />
        ))}
      </div>
    </div>
  );
}
